import { render, staticRenderFns } from "./CustomTablePagination.vue?vue&type=template&id=209c78af&scoped=true&"
import script from "./CustomTablePagination.vue?vue&type=script&lang=js&"
export * from "./CustomTablePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209c78af",
  null
  
)

export default component.exports